import { useState, useEffect } from "react";
import axios from "axios";
import config from "../../Common/Configurations/APIConfig";
import { handleSuccess, handleError } from "../../Common/Layout/CustomAlerts";
import LayoutHeader from "../../Common/Layout/Header";
import LayoutSideBar from "../../Common/Layout/Sidebar";
import { Link } from "react-router-dom";

const initialFieldValues = {
  companyId: "00000000-0000-0000-0000-000000000000",
  companyName: "",
  address: "",
  phoneNumber: "",
  email: "",
  isActive: "",
};

export default function Company() {
  const [lists, setLists] = useState([]);
  const [values, setValues] = useState(initialFieldValues);
  const [recordForEdit, setRecordForEdit] = useState(null);
  const [errors, setErrors] = useState({});
  const [btnSubmit, setBtnSubmit] = useState(true);
  const [totalPages, setTotalPages] = useState(0);
  const [pageSize] = useState(20);
  const [pageNumber, setPageNumber] = useState(1);
  const [totalRecords, setTotalRecords] = useState(0);
  const [userCompanyId, setUserCompanyId] = useState("");
  const userId = localStorage.getItem("userId");

  const headerconfig = {
    headers: {
      Authorization: "Bearer " + localStorage.getItem("userToken"),
    },
  };

  useEffect(() => {
    if (recordForEdit !== null) {
      setValues(recordForEdit);
    }
  }, [recordForEdit]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setValues({ ...values, [name]: value });
  };

  const resetForm = () => {
    setValues(initialFieldValues);
    setErrors({});
  };

  const showEditDetails = (data) => {
    setRecordForEdit(data);
  };

  const GetPageData = (number) => {
    if (number >= 1 && number <= totalPages) {
      setPageNumber(number);
      GetData(number);
    }
  };

  const pageNumbers = [];
  for (let i = 1; i <= totalPages; i++) {
    pageNumbers.push(i);
  }

  const renderPageNumbers = pageNumbers.map((number) => {
    return (
      <li
        className="page-item"
        key={number}
        id={number}
        onClick={() => GetPageData(number)}
      >
        <Link className="page-link">{number}</Link>
      </li>
    );
  });

  const validate = () => {
    let temp = {};
    temp.companyName = values.companyName === "" ? false : true;
    temp.address = values.address === "" ? false : true;
    temp.phoneNumber = values.phoneNumber === "" ? false : true;
    temp.email = values.email === "" ? false : true;
    temp.isActive = values.isActive === "" ? false : true;

    setErrors(temp);
    return Object.values(temp).every((x) => x === true);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (validate()) {
      setBtnSubmit(false);
      const formData = new FormData();
      formData.append("companyId", values.companyId);
      formData.append("companyName", values.companyName);
      formData.append("parentCompanyId", userCompanyId); // <-- used directly
      formData.append("address", values.address);
      formData.append("phoneNumber", values.phoneNumber);
      formData.append("email", values.email);
      formData.append("isActive", values.isActive);
      addOrEdit(formData);
    }
  };

  const applicationAPI = () => {
    return {
      create: (newRecord) =>
        axios.post(config.APIACTIVATEURL + config.CREATECOMPANY, newRecord, {
          ...headerconfig,
        }),
      update: (updateRecord) =>
        axios.put(config.APIACTIVATEURL + config.UPDATECOMPANY, updateRecord, {
          ...headerconfig,
        }),
    };
  };

  const addOrEdit = (formData) => {
    if (formData.get("companyId") === "00000000-0000-0000-0000-000000000000") {
      applicationAPI()
        .create(formData)
        .then((res) => {
          if (res.data.statusCode === 200) {
            handleSuccess(res.data.data);
            resetForm();
            GetData(pageNumber);
            setBtnSubmit(true);
          } else {
            handleError(res.data.data);
            setBtnSubmit(true);
          }
        })
        .catch(function (error) {
          handleError("Error in saving data");
          setBtnSubmit(true);
        });
    } else {
      applicationAPI()
        .update(formData)
        .then((res) => {
          if (res.data.statusCode === 200) {
            handleSuccess(res.data.data);
            resetForm();
            GetData(pageNumber);
            setBtnSubmit(true);
          } else {
            handleError(res.data.data);
            setBtnSubmit(true);
          }
        })
        .catch(function (error) {
          handleError("Error in updating data");
          setBtnSubmit(true);
        });
    }
  };
  const onDelete = (e, id) => {
    if (window.confirm("Are you sure to delete this record?")) {
      axios
        .delete(config.APIACTIVATEURL + config.DELETECOMPANY + "/" + id, {
          ...headerconfig,
        })
        .then((response) => {
          if (response.data.statusCode === 200) {
            handleSuccess(response.data.data);
            GetData(pageNumber);
            resetForm();
          } else {
            handleError(response.data.data);
            GetData(pageNumber);
            resetForm();
          }
        });
    }
  };

  const GetData = (number) => {
    axios
      .get(
        config.APIACTIVATEURL +
          config.GETCOMPANIES +
          "?userId=" +
          userId +
          "&pageNumber=" +
          number +
          "&pageSize=" +
          pageSize,
        { ...headerconfig }
      )
      .then((response) => {
        const resData = response.data.data;
        setLists(resData.data);
        setTotalPages(resData.totalPages);
        setTotalRecords(resData.totalRecords);
      })
      .catch(() => {
        handleError("Error fetching data");
      });
  };

  const GetUserData = () => {
    axios
      .get(config.APIACTIVATEURL + config.GETUSERBYID + "/" + userId, {
        ...headerconfig,
      })
      .then((res) => {
        if (res.data.statusCode === 200 && res.data.data) {
          setUserCompanyId(res.data.data.companyId);
        }
      });
  };

  const applyErrorClass = (field) =>
    field in errors && !errors[field] ? " form-control-danger" : "";

  useEffect(() => {
    GetUserData();
    GetData(pageNumber);
  }, []);

  return (
    <div id="layout-wrapper">
      <LayoutHeader />
      <LayoutSideBar />
      <div className="main-content">
        <div className="page-content">
          <div className="container-fluid">
            <div className="row">
              <div className="col-12">
                <div className="page-title-box d-sm-flex align-items-center justify-content-between">
                  <h4 className="mb-sm-0">Channel Partners</h4>
                </div>
              </div>
            </div>
            <div className="alert alert-success">
              <form onSubmit={handleSubmit} autoComplete="off" noValidate>
                <div className="row">
                  <div className="col-lg-4">
                    <div className="mb-3">
                      <label htmlFor="companyName" className="form-label">
                        Company Name*
                      </label>
                      <input
                        type="text"
                        name="companyName"
                        value={values.companyName}
                        onChange={handleInputChange}
                        className={
                          "form-control " + applyErrorClass("companyName")
                        }
                        placeholder="Enter Company Name"
                      />
                      {errors.companyName === false && (
                        <div className="validationerror">
                          Please enter company name
                        </div>
                      )}
                    </div>
                  </div>
                  <div className="col-lg-4">
                    <div className="mb-3">
                      <label htmlFor="address" className="form-label">
                        Address
                      </label>
                      <input
                        type="text"
                        name="address"
                        value={values.address}
                        onChange={handleInputChange}
                        className="form-control"
                        placeholder="Enter Address"
                      />
                      {errors.address === false && (
                        <div className="validationerror">
                          Please enter address
                        </div>
                      )}
                    </div>
                  </div>
                  <div className="col-lg-4">
                    <div className="mb-3">
                      <label htmlFor="phoneNumber" className="form-label">
                        Phone Number
                      </label>
                      <input
                        type="text"
                        name="phoneNumber"
                        value={values.phoneNumber}
                        onChange={handleInputChange}
                        className="form-control"
                        placeholder="Enter Phone Number"
                        maxLength={15}
                      />
                      {errors.phoneNumber === false && (
                        <div className="validationerror">
                          Please enter phoneNumber
                        </div>
                      )}
                    </div>
                  </div>
                </div>
                <div className="row">
                  <div className="col-lg-4">
                    <div className="mb-3">
                      <label htmlFor="email" className="form-label">
                        Email
                      </label>
                      <input
                        type="email"
                        name="email"
                        value={values.email}
                        onChange={handleInputChange}
                        className={"form-control " + applyErrorClass("email")}
                        placeholder="Enter Email"
                      />
                      {errors.email === false && (
                        <div className="validationerror">
                          Please enter a valid email
                        </div>
                      )}
                    </div>
                  </div>
                  <div className="col-lg-4">
                    <div className="mb-3">
                      <label htmlFor="status" className="form-label">
                        Status*
                      </label>
                      <select
                        name="isActive"
                        value={values.isActive}
                        onChange={handleInputChange}
                        className={"form-select " + applyErrorClass("email")}
                      >
                        <option value="">Please Select</option>
                        <option value="true">Active</option>
                        <option value="false">InActive</option>
                      </select>
                      {errors.isActive === false && (
                        <div className="validationerror">Please select</div>
                      )}
                    </div>
                  </div>

                  <div className="col-lg-4">
                    <div className="hstack gap-2 justify-content-end mb-3 mt-4">
                      {btnSubmit === true ? (
                        <button type="submit" className="btn btn-primary w-100">
                          {values.companyId ===
                          "00000000-0000-0000-0000-000000000000"
                            ? "Submit"
                            : "Update"}
                        </button>
                      ) : (
                        <button
                          type="submit"
                          className="btn btn-primary w-100"
                          disabled
                        >
                          Please wait...
                        </button>
                      )}
                      <button
                        type="button"
                        className="btn btn-danger w-100"
                        onClick={resetForm}
                      >
                        Cancel
                      </button>
                    </div>
                  </div>
                </div>
              </form>
            </div>
            <div className="row">
              <div className="col-xl-12">
                <div className="card card-height-100">
                  <div className="card-body">
                    <div className="table-responsive table-card">
                      <table className="table align-middle">
                        <thead className="table-light">
                          <tr>
                            <th>S.NO</th>
                            <th>Company Name</th>
                            <th>Address</th>
                            <th>Phone</th>
                            <th>Email</th>
                            <th>Status</th>
                            <th>Action</th>
                          </tr>
                        </thead>
                        <tbody>
                          {lists.map((v, index) => (
                            <tr key={v.companyId}>
                              <td>
                                {(pageNumber - 1) * pageSize + (index + 1)}
                              </td>
                              <td>{v.companyName}</td>
                              <td>{v.address}</td>
                              <td>{v.phoneNumber}</td>
                              <td>{v.email}</td>
                              <td>
                                <span
                                  className={`badge bg-${
                                    v.isActive ? "success" : "danger"
                                  } text-uppercase`}
                                >
                                  {v.isActive ? "Active" : "Inactive"}
                                </span>
                              </td>
                              <td>
                                <ul className="list-inline hstack gap-2 mb-0">
                                  <li>
                                    <Link
                                      className="edit-item-btn"
                                      onClick={() => showEditDetails(v)}
                                    >
                                      <i className="ri-pencil-fill text-muted" />
                                    </Link>
                                  </li>
                                  <li>
                                    <Link
                                      className="remove-item-btn"
                                      onClick={(e) => onDelete(e, v.companyId)}
                                    >
                                      <i className="ri-delete-bin-fill text-muted" />
                                    </Link>
                                  </li>
                                </ul>
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                    <div className="align-items-center mt-4 pt-2 justify-content-between d-flex">
                      <div className="flex-shrink-0">
                        <div className="text-muted">
                          Showing{" "}
                          <span className="fw-semibold">{lists.length}</span> of{" "}
                          <span className="fw-semibold">{totalRecords}</span>{" "}
                          Results
                        </div>
                      </div>
                      <ul className="pagination pagination-separated pagination-sm mb-0">
                        <li
                          className={
                            "page-item " + (pageNumber === 1 ? "disabled" : "")
                          }
                          onClick={() => GetPageData(pageNumber - 1)}
                        >
                          <Link className="page-link">Previous</Link>
                        </li>

                        {renderPageNumbers}

                        <li
                          className={
                            "page-item " +
                            (pageNumber === totalPages ? "disabled" : "")
                          }
                          onClick={() => GetPageData(pageNumber + 1)}
                        >
                          <Link className="page-link">Next</Link>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
